import React from 'react';
import { useData } from '../../hooks';
import { useRTL } from 'ca-hooks';
import styles from './WelcomeScreenFooter.scss';
import { Paragraph } from '@kaizen/typography';
import { CaLogo } from 'ca-logo';
import { FormattedMessage } from '@cultureamp/i18n-react-intl';

export const WelcomeScreenFooter = () => {
  const { account_name, welcome_screen_locale } = useData();
  const isRTL = useRTL(welcome_screen_locale.code);

  return (
    <div className={styles.WelcomeScreenFooterContainer}>
      <div className={styles.WelcomeScreenFooterLogo}>
        <div className={styles.WelcomeScreenFooterLogoText}>
          <Paragraph
            variant="extra-small"
            classNameOverride={styles.WelcomeScreenPoweredBy}
          >
            <FormattedMessage
              id="welcome_screen.powered_by"
              defaultMessage="Powered by"
            />
          </Paragraph>
        </div>
        <CaLogo styles={styles.WelcomeScreenFooterLogoImage} />
      </div>
      <div
        data-automation-id="welcome-screen-footer"
        className={styles.WelcomeScreenFooterText}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        <Paragraph variant="extra-small">
          <FormattedMessage
            id="welcome_screen.footer_text"
            defaultMessage="<strong>Who is Culture Amp?</strong> Culture Amp is an employee experience platform. Your employer, {account_name}, is the controller of your personal information and Culture Amp is the data processor. Requests to edit or delete your personal information need to be made via your employer. Got questions? <a>support@cultureamp.com</a>."
            values={{
              a: (chunks) => (
                <a target="_blank" href="mailto:support@cultureamp.com">
                  {chunks}
                </a>
              ),
              strong: (chunks) => <strong>{chunks}</strong>,
              account_name,
            }}
          />
        </Paragraph>
      </div>
    </div>
  );
};
